import React, { useState, useEffect} from 'react'
import './App.css';
import Post from "./Post";
import PostThumb from "./PostThumb";
import { db, auth } from "./firebase";
import {makeStyles } from '@material-ui/core/styles';
import {Modal} from '@material-ui/core';
import {Button, Input} from '@material-ui/core';
import ImageUpload from "./ImageUpload"
import InstagramEmbed from 'react-instagram-embed';
import Avatar from "@material-ui/core/Avatar";
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import LazyLoad from "react-lazyload";
import MenuPopupState from "./components/MenuPopupState"
import InstallPrompt from "./components/InstallPrompt"
import getUserLocale from 'get-user-locale'


function backToTop(){
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

function getModalStyle() {
  const top = 50; 
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    maxWidth: 'calc(100% - 32px)',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 18,
    border: '1px solid var(--green-line)',
    boxShadow: '0 20px 50px rgba(0, 48, 0, 0.18)',
    outline: 'none',
    padding: theme.spacing(3.5, 4),
  },
}));

const Spinner = () => (
  <div className="post loading">
    <div className="app__spinner" />
    <span>Loading...</span>
  </div>
);


// Determine language from the user's computer or browser

const locale =() => {
  
  if (getUserLocale().includes("fr")) {
    return(true)
  } else {
    return(false)
  }
}

// Lowercase and strip accents so that "ete" also matches "Été"
function normalizeText(text) {
  return (text || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

const LANGUAGE_PREFERENCE_KEY = "languagePreference";

function getInitialLanguage() {
  try {
    const savedLanguage = window.localStorage.getItem(LANGUAGE_PREFERENCE_KEY);
    if (savedLanguage === "fr") {
      return true;
    }
    if (savedLanguage === "en") {
      return false;
    }
  } catch (error) {
    console.error("Error reading language preference: ", error);
  }

  return locale();
}

function App() {

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [posts, setPosts] = useState([]);
  const [open, setOpen] = useState(false);
  const [openImageUpload, setOpenImageUpload] = useState(false);
  const [openSignIn, setOpenSignIn] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [user, setUser] = useState(null);
  const [viewmine, setViewMine] = useState(false);
  const [viewwhichuser, setViewWhichUser] = useState('');
  const [viewsinglepost, setViewSinglePost] = useState(false);
  const [singlepostid, setSinglePostId] = useState('');
  const [lang, setLang] = useState(getInitialLanguage);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [installPrompt, setInstallPrompt] = useState(null);
  const [isStandalone, setIsStandalone] = useState(false);
  const [showInstallGuide, setShowInstallGuide] = useState(false);

  useEffect(() => {
    const isStandaloneMode = Boolean(
      (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
      window.navigator.standalone
    );
    setIsStandalone(isStandaloneMode);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
    };

    const handleAppInstalled = () => {
      setIsStandalone(true);
      setInstallPrompt(null);
      setShowInstallGuide(false);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstallApp = () => {
    if (installPrompt) {
      installPrompt.prompt();
      installPrompt.userChoice.then((choiceResult) => {
        if (choiceResult && choiceResult.outcome === 'accepted') {
          setInstallPrompt(null);
        }
      });
    } else {
      setShowInstallGuide(true);
    }
  };

  // This is to toggle from FR to EN
  const toggleLang = () => {
    const nextLanguage = !lang;
    setLang(nextLanguage);

    try {
      window.localStorage.setItem(
        LANGUAGE_PREFERENCE_KEY,
        nextLanguage ? "fr" : "en"
      );
    } catch (error) {
      console.error("Error saving language preference: ", error);
    }
  };


  // The below is what checks if you are logged in or not, and keeps you logged in on refresh
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        // if user has logged in...
        setUser(authUser);

      } else {
        // if user has logged out... 
        setUser(null);
      }
      
    })

    return () => {
      // perform some cleanup actions
      unsubscribe();
    }
  }, [user, username]);

  useEffect(() => {
      // This is where the code runs
      db.collection('posts').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
        // every time a new post is added, this code fires up
        setPosts(snapshot.docs.map(doc => ({
          id: doc.id,
          post: doc.data()
        })));
      })
  }, []);

  // To automatically change language text desc - Not necessary for now actually
/*   useEffect((toggleLang) => {
        // To toggle lang
        if (lang) {
          // If user clicked FR
          setLang("FR")
          console.log(lang)
        } else {
          setLang("EN")
          console.log(lang)
        }  
  })
 */
  const signUp = (event) => {

    // This is to prevent the page from refreshing when we submit the form
    event.preventDefault();
    auth.createUserWithEmailAndPassword(email, password)
    .then((authUser) => {
      return authUser.user.updateProfile({
        displayName: username
      })
    })
    .catch((error) => alert(error.message));

    // Set user so that footer changes accordingly
    

    // Close modal
    setOpen(false);
  }

  const signIn = (event) => {
    event.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .catch((error) => alert(error.message));
    
    // Close modal
    setOpenSignIn(false);
  }

  function closeSearch() {
    setSearchOpen(false);
    setSearchQuery('');
  }

  function home() {
    setViewMine(false); 
    setViewWhichUser(''); 
    setViewSinglePost(false); 
    closeSearch();
    backToTop();    
  }

  // Grid of thumbnails, clicking one opens that single post
  function renderThumbs(postsToShow) {
    if (!postsToShow || postsToShow.length === 0) {
      return (
        <div className="post__thumbsEmpty">
          <p>{lang ? "Aucune publication pour le moment" : "No posts yet"}</p>
        </div>
      );
    }

    return (
      <div className="post__thumbs">
        {postsToShow.map(({id, post}) => (
          <LazyLoad 
            key={id}
            height={120}
            offset={[-50, 100]}
            placeholder={<div className="post__thumbPlaceholder"><div className="app__spinner" /></div>}
            >
              <div 
                className="post__thumbItem"
                onClick={() => {setViewSinglePost(true); setSinglePostId(id); setViewMine(false); setViewWhichUser(null); closeSearch(); backToTop(); }}
              >
                <PostThumb 
                    key={id}
                    lang={lang}
                    postId={id}
                    user={user}
                    username={post.username}
                    caption={post.caption}
                    imageUrl={post.imageUrl}
                />
              </div>
            </LazyLoad>
        ))}
      </div>
    );
  }

  const normalizedQuery = normalizeText(searchQuery.trim());
  const searchResults = normalizedQuery
    ? posts.filter(({post}) =>
        normalizeText(post.caption).includes(normalizedQuery) ||
        normalizeText(post.username).includes(normalizedQuery)
      )
    : [];

  const isGridView = Boolean(
    normalizedQuery
      ? searchResults.length > 0
      : (viewmine && user) || Boolean(viewwhichuser)
  );


  return (
    <div className="app">

      <Modal  
        open={open}
        onClose={() => setOpen(false)}
      >
        <div style={modalStyle} className={classes.paper}>
          <form className="app__signup">
            <center>
              <img 
                className="app__headerImage"
                height="40px;"
                src="https://toogreen.ca/instagreen/img/instagreen.svg"
                alt=""
              />
            </center>

            <Input 
              type="text"
              placeholder={lang ? "Nom d'utilisateur":"username"}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            /> 
            <Input 
              placeholder={lang ? "Courriel":"email"}
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Input 
              placeholder={lang ? "Mot de passe":"password"}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button type="submit" onClick={signUp}>{lang ? "Inscrivez-vous":"Sign Up"}</Button>

          </form>

        </div>
      </Modal>

      <Modal  
        open={openSignIn}
        onClose={() => setOpenSignIn(false)}
      >
        <div style={modalStyle} className={classes.paper}>
          <form className="app__signup">
            <center>
              <img 
                className="app__headerImage"
                src="https://toogreen.ca/instagreen/img/instagreen.svg"
                height="40px;"
                alt=""
              />
            </center>

            <Input 
              placeholder={lang ? "Courriel":"email"}
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Input 
              placeholder={lang ? "Mot de passe":"password"}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button type="submit" onClick={signIn}>{lang ? "Connectez-vous":"Sign In"}</Button>

          </form>

        </div>
      </Modal>

      <header className="app__header">
        <div className="app__headerInner">
          <img 
            className="app__headerImage"
            src="https://toogreen.ca/instagreen/img/instagreen.svg"
            height="36"
            alt="Instagreen"
            onClick={home}
          />

          <div className="app__loginContainer">

                <div className="loginLeft">
                  { user ? (
                    <Button onClick={() => auth.signOut()}>{lang ? "Déconnecter":"Logout"}</Button>
                  ) : (
                    <Button onClick={() => toggleLang()}>{lang ? "EN":"FR"}</Button>
                  )
                  }
               </div>

              <div className="app__searchToggle">
                <Button
                  aria-label={lang ? "Rechercher" : "Search"}
                  onClick={() => searchOpen ? closeSearch() : setSearchOpen(true)}
                >
                  <SearchIcon />
                </Button>
              </div>

              <div className="loginRight">
                <Button aria-controls="fade-menu" aria-haspopup="true"> 
                  <MenuPopupState 
                    topmenu={true}
                    lang={lang}
                    user={user}
                    functiontopass={toggleLang}
                    labeltopass={lang ? "English Version" : "Version française"}
                    signout={() => auth.signOut()}
                    signoutlabel={lang ? "Déconnecter":"Logout"}
                    signin={() => setOpenSignIn(true)}
                    signinlabel={lang ? "Me Connecter" : "Sign In"}
                    signup={() => setOpen(true)}
                    signuplabel={lang ? "M'enregistrer" : "Sign Up"}
                    installapp={!isStandalone ? handleInstallApp : null}
                    installapplabel={lang ? "Installer l'application" : "Install App"}
                  />
                </Button>
              </div>

            </div>
        </div>

        {searchOpen && (
          <div className="app__searchWrapper">
            <div className="app__search">
              <SearchIcon className="app__searchIcon" />
              <Input
                autoFocus
                fullWidth
                disableUnderline
                placeholder={lang ? "Rechercher des publications ou des utilisateurs" : "Search posts or users"}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => e.key === "Escape" && closeSearch()}
              />
              <CloseIcon
                className="app__searchClose"
                aria-label={lang ? "Fermer la recherche" : "Close search"}
                onClick={closeSearch}
              />
            </div>
          </div>
        )}

      </header>

        <div className={`app__posts ${isGridView ? 'app__posts--grid' : ''}`}>
          <div className={`app__postsLeft ${isGridView ? 'app__postsLeft--grid' : ''}`}>
            {
            // If something was typed in the search bar, show matching posts
            normalizedQuery ? (

              searchResults.length ? renderThumbs(searchResults) : (
                <p className="app__searchEmpty">
                  {lang ? "Aucune publication trouvée" : "No posts found"}
                </p>
              )

            // If "View my own posts button was clicked AND user is logged in"
            ) : (viewmine && user)  ? (

              renderThumbs(posts.filter(({id, post}) => post.username === auth.currentUser.displayName))

            ) : (viewwhichuser)  ? ( // If we want to see other people's list of posts

              renderThumbs(posts.filter(({id, post}) => post.username === viewwhichuser))

            ) : viewsinglepost ? ( 

              // If a single post was selected
        
              posts.filter(({id, post}) => id === singlepostid).map(({id, post}) => (
                <Post 
                    key={id}
                    lang={lang}
                    postId={id}
                    user={user}
                    username={post.username}
                    caption={post.caption}
                    likes={post.likes}
                    imageUrl={post.imageUrl}
                    imagename={post.imagename}
                    viewwhichuser={setViewWhichUser}
                    viewsinglepost={setViewSinglePost}
                />                             
              ))
                  
            ) : (

              // Else if no posts were selected at all, simply default to display all posts as usual
            
              posts.map(({id, post}) => (

                <LazyLoad 
                  key={id}
                  height={100}
                  offset={[-100, 100]}
                  placeholder={<Spinner />}
                  >
                    <Post 
                        key={id}
                        lang={lang}
                        postId={id}
                        user={user}
                        username={post.username}
                        caption={post.caption}
                        likes={post.likes}
                        imageUrl={post.imageUrl}
                        imagename={post.imagename}
                        viewwhichuser={setViewWhichUser}
                        viewsinglepost={setViewSinglePost}
                    />  
                  </LazyLoad>

              ))

            )
            }

          </div>
          {!isGridView && (
            <div className="app__postsRight no-mobile">
              <div className="floating">
                {user ? (
                  <div className="app__sidebarProfile" onClick={() => { setViewMine(true); backToTop(); }}>
                    <Avatar 
                      className="app__sidebarAvatar"
                      alt={user.displayName || "User"}
                      src="https://toogreen.ca/instagreen/static/images/avatar/1.jpg"
                    />
                    <div className="app__sidebarInfo">
                      <span className="app__sidebarUsername">{user.displayName || "User"}</span>
                      <span className="app__sidebarSubtext">{lang ? "Voir mes publications" : "View my posts"}</span>
                    </div>
                  </div>
                ) : (
                  <div className="app__sidebarCard">
                    <h4>Instagreen</h4>
                    <p>{lang ? "Partagez et découvrez des moments uniques." : "Share and discover green moments."}</p>
                  </div>
                )}

                <InstagramEmbed
                  url="https://instagr.am/p/CAX8psZMEdL_Lkto_rA_8oIhfVE1IJNLUobpkc0/"
                  maxWidth={320}
                  hideCaption={false}
                  containerTagName="div"
                  protocol=""
                  injectScript
                  onLoading={() => {}}
                  onSuccess={() => {}}
                  onAfterRender={() => {}}
                  onFailure={() => {}}
                />
              </div>
            </div>
          )}
        </div>

      <footer className="footer">

        {/* This is where people can upload stuff */}
        {/* below line used to be user?.displayName ? (  - but it was giving issues so i changed it */}
        {user ? (

          <div>
            <Modal  
              open={openImageUpload}
              onClose={() => setOpenImageUpload(false)}
            >
              <ImageUpload 
                lang={lang}
                username={user.displayName} 
                closemodal={setOpenImageUpload} 
                // Passing the 2 below so that I can reset those once upload is done
                viewwhichuser={setViewWhichUser}
                viewsinglepost={setViewSinglePost}

              />
            </Modal>
            

            <div className="footer__icons">
              <div className="footer__left">
                <img onClick={home} className="app__home" src="https://toogreen.ca/instagreen/img/home.svg" alt='home icon to go back up'/>         
              </div>

              <div className="footer__middle">
                <img onClick={() => setOpenImageUpload(true)} className="app__add-postImg" src="https://toogreen.ca/instagreen/img/add-post.svg" alt='plus icon to add posts'/>
              </div>

              <div className="footer__right">
                  <img
                      onClick={() => { setViewMine(true); backToTop(); }}
                      className="app__profileImg footer__avatar"
                      alt={username || "Profile"}
                      src={`${process.env.PUBLIC_URL || 'https://toogreen.ca/instagreen'}/img/user.svg`}
                      onError={(e) => {
                        if (e.currentTarget.src !== 'https://toogreen.ca/instagreen/img/user.svg') {
                          e.currentTarget.src = 'https://toogreen.ca/instagreen/img/user.svg';
                        }
                      }}
                  />  
              </div>
            </div>

          </div>
        ): (
          <div className="footer__icons">
              <div className="footer__left">
                <img onClick={home} className="app__home" src="https://toogreen.ca/instagreen/img/home.svg" alt='home icon to go back up'/>         
              </div>
              <div className="footer__middle">
                  <Button className="footer__authBtn footer__authBtn--secondary" onClick={() => setOpenSignIn(true)}>
                    {lang ? "CONNEXION":"SIGN IN"}
                  </Button> 
                  <Button className="footer__authBtn footer__authBtn--primary" onClick={() => setOpen(true)}>
                    {lang ? "INSCRIPTION":"SIGN UP"}
                  </Button>
              </div>
              <div className="footer__right">
                  &nbsp;
              </div>                       
          </div>
          
        )}  
      </footer>

      <InstallPrompt
        lang={lang}
        isStandalone={isStandalone}
        onInstall={handleInstallApp}
        showGuide={showInstallGuide}
        onCloseGuide={() => setShowInstallGuide(false)}
      />
    </div>
  );
}

export default App;
